import { IconButton, Stack } from '@mui/material';

import { styled } from '@/theme/styled';
import { getBorder } from '@/theme/utils';

import { StatusColors as StatusColorsBase } from '../../styled';

const Container = styled(Stack)(({ theme }) => ({
  width: 300,
  borderLeft: getBorder(theme.palette.border.default),
}));

const Section = styled(Stack)(({ theme }) => ({
  borderBottom: getBorder(theme.palette.border.default),
  padding: theme.spacing(2),
}));

const SettingsItemIcon = styled(Stack)(({ theme }) => ({
  width: 32,
  height: 32,
  backgroundColor: theme.palette.background.subtle,
  justifyContent: 'center',
  alignItems: 'center',
  borderRadius: theme.shape.borderRadius,
}));

const StatusColors = styled(StatusColorsBase)(({ theme }) => ({
  height: 6,
  borderRadius: theme.shape.borderRadius,
  overflow: 'hidden',
  backgroundColor: theme.palette.background.subtle,
}));

const DeploymentsChevronIconContainer = styled(IconButton)(({ theme }) => ({
  marginRight: theme.spacing(-1),
}));

export { Container, Section, SettingsItemIcon, StatusColors, DeploymentsChevronIconContainer };
